import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { nocModeSelector, autoSortEnabledSelector } from '@store/noc/base/selectors';
import { tid } from '@utils/test';
import { NOC_MODE_FILTERS } from '@utils/constants';
import { selectedFiltersProps, selectedTrendsProps } from '../../MetricDropdown/utils';
import DragableColumnTable from './DragableColumnTable';
import { TableWrapper } from '../styled';

// pure table

function getIconType(isAutoSortEnabled, sortOrder) {
  if (isAutoSortEnabled) {
    return '';
  }
  return sortOrder === 'asc' ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
}

function DataTable({ data, columns, sort = {}, onColumnSort, total }) {
  const mode = useSelector(nocModeSelector);
  const dispatch = useDispatch();
  const metricProps = mode === NOC_MODE_FILTERS ? selectedFiltersProps : selectedTrendsProps;
  const metrics = useSelector(metricProps.metricSelector);
  const isAutoSortEnabled = useSelector(autoSortEnabledSelector);

  const AdvanceSortIndicator = (data) => {
    const { className, sortOrder } = data;
    return (
      <div className={className} style={{ lineHeight: 1 }}>
        {getIconType(isAutoSortEnabled, sortOrder)}
      </div>
    );
  };

  const onColumnOrderChange = (oldIndex, newIndex) => {
    const orderedMetrics = metrics.map((item) => item);
    [orderedMetrics[newIndex - 1], orderedMetrics[oldIndex - 1]] = [
      orderedMetrics[oldIndex - 1],
      orderedMetrics[newIndex - 1],
    ];
    dispatch(metricProps.setMetrics(orderedMetrics));
  };

  return (
    <TableWrapper {...tid('noc-table')}>
      <DragableColumnTable
        data={data}
        total={total}
        columns={columns}
        rowHeight={86}
        headerHeight={55}
        sortBy={sort}
        onColumnSort={onColumnSort}
        onColumnOrderChange={onColumnOrderChange}
        components={{ SortIndicator: AdvanceSortIndicator }}
      />
    </TableWrapper>
  );
}

export default React.memo(DataTable);
